import React, {FC, useEffect, useState} from "react";
import {Alert, Button, Card, Col, Container, Row} from "react-bootstrap";
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {useAuth} from "../../context/AuthProvider";
import moment from "moment/moment";

type BookingInfoComponentProps = Record<string, any>

const BookingInfoComponent: FC<BookingInfoComponentProps> = () => {
    const params = useParams()
    const {t} = useTranslation("booking")
    const nav = useNavigate()
    const auth = useAuth()

    useEffect(() => {
        axios.get("/api/exam/bookingInfo/" + params.id, auth.axiosAuthHeader()).then((response) => {
            setBooking(response.data)
        });
    }, [])
    const [booking, setBooking] = useState<any>(null)
    const [view, setView] = useState<number>(0)
    const cancelBooking = () => {
        axios.get("/api/exam/bookingAbort/" + params.id, auth.axiosAuthHeader()).then(() => {
            nav("/booking")
        });
    };
    return (<div className="component">
        <Container>
            <Row>
                <Col>
                    {booking ? <Card>
                        <Card.Header><h2>{t('bookingInfo.title')}: {booking.exam.name_de}</h2></Card.Header>
                        <Card.Body>
                            <Row>
                                <Col>
                                    <h4>{t('booking.step3.info2')}</h4>
                                    <ul>
                                        <li>{t('booking.step3.info2')}{" "}
                                            <b>{moment(booking.bookingSlot.startAt).format("DD.MM.YYYY")}</b> {t('booking.step3.info4')}
                                        </li>
                                        <li>
                                            <b>{moment(booking.bookingSlot.entryAt).format("HH:mm")}</b>{" "}{t('booking.step3.info5')}
                                        </li>
                                        <li>
                                            <b>{moment(booking.bookingSlot.startAt).format("HH:mm")}</b>{" "}{t('booking.step3.info6')}
                                        </li>
                                        <li>
                                            <b>{moment(booking.bookingSlot.startAt).add(booking.exam.duration, "minutes").format("HH:mm")}</b>{" "}{t('booking.step3.info7')}{" "}{booking.duration}{" "}{t('examSelect.briefing.4')}.
                                        </li>
                                        <li>{t('booking.step3.info8')}{" "}
                                            <b>{moment(booking.bookingSlot.leaveUntil).format("HH:mm")}</b> {t('booking.step3.info9')}
                                        </li>
                                        <li>{t('booking.step3.info10a')}{" "}
                                            <b>{t('booking.step3.info10b')}</b>{" "}{t('booking.step3.info10c')}
                                        </li>
                                    </ul>
                                    <h4>{t('booking.step3.info11')}</h4>
                                    <ul>
                                        <li>{t('booking.step3.info12')}</li>
                                        <li>{t('booking.step3.info13')}</li>
                                        <li>{t('booking.step3.info14')}</li>
                                        <li>{t('booking.step3.info15')}</li>
                                    </ul>
                                </Col>
                                <Col>
                                    <h4>{t('booking.step3.info16')}</h4>
                                    <ul>
                                        <li>{t('booking.step3.info17')}
                                            <ul>
                                                <li className="text-muted">{t('booking.step3.info18')}</li>
                                                <li className="text-muted">{t('booking.step3.info19')}</li>
                                                <li className="text-muted">{t('booking.step3.info20')}</li>
                                                <li className="text-muted">{t('booking.step3.info21')}</li>
                                                <li className="text-muted">{t('booking.step3.info22')}</li>
                                            </ul>
                                        </li>
                                        <li>{t('booking.step3.info23')}</li>
                                        <li>{t('booking.step3.info23a')}</li>
                                        <li>{t('booking.step3.info24')}</li>
                                    </ul>
                                    <h4>{t('booking.step3.info25')}</h4>
                                    <ul>
                                        <li>{t('booking.step3.info26')}</li>
                                    </ul>
                                    <h4>{t('booking.step3.info27')}</h4>
                                    <ul>
                                        <li>{t('booking.step3.info28')}{" "}
                                            <b>{booking.prefersMouseLeft ? t('user.settings.value.prefersMouseRight.left', {ns: 'settings'}) : t('user.settings.value.prefersMouseRight.right', {ns: 'settings'})}</b>,
                                        </li>
                                        <li>{t('booking.step3.info29')}{" "}
                                            <b>{t('booking.step1.keyboardLayout.qwertz')}</b>,
                                        </li>
                                        {booking.keyboardLayout === "QWERTY" ?
                                            <li>{t('booking.step3.info29')}
                                                <b>{t('booking.step1.keyboardLayout.qwerty')}</b>,
                                            </li> : null}
                                        {booking.keyboardLayout === "AZERTY" ?
                                            <li>{t('booking.step3.info29')}
                                                <b>{t('booking.step1.keyboardLayout.azerty')}</b>,
                                            </li> : null}
                                        <li>{t('booking.step3.info30')}</li>
                                    </ul>
                                </Col>
                            </Row>
                            {moment().isBefore(booking.exam.closeBookingAt) ? <Row>
                                <Col className="d-flex justify-content-end"><Button onClick={() => setView(1)}
                                                                                    variant="danger">{t('bookingInfo.cancel.btn')}</Button></Col>
                            </Row> : null}
                        </Card.Body>
                    </Card> : null}
                </Col>
            </Row>
            {view == 1 ? <Row className="mt-2">
                <Col>
                    <Alert className="text-center"
                           variant="danger"><b>{t('bookingInfo.cancel.prompt1')}</b> {t('bookingInfo.cancel.prompt2')}<br/><Button
                        onClick={() => cancelBooking()}
                        className="align-self-end"
                        variant="danger" size="lg">{t('bookingInfo.cancel.btnyes')}</Button><br/>
                        <i>{t('bookingInfo.cancel.prompt3')}</i>
                    </Alert>
                </Col>
            </Row> : null}
        </Container>
    </div>)
}

export default BookingInfoComponent
